<li class="padding-bottom-0 first-item" role="menuitem">
  <a
    *ngIf="currentRoute !== '/' + helpLink; else helpActive"
    [routerLink]="['/', helpLink]"
    class="button square border-transparent flex-dir-column button--icon-on-top margin-left-0-5"
  >
    <svg
      class="icon icon--help icon--primary icon--material"
      viewBox="0 0 24 24"
    >
      <use xlink:href="#icon-help" href="#icon-help"></use>
    </svg>
    <div
      class="icon-text"
    >
      {{ helpText ? helpText : 'help'}}
    </div>
  </a>
  <ng-template #helpActive>
    <span
      class="button square border-transparent flex-dir-column button--icon-on-top margin-left-0-5 active"
    >
      <svg
        class="icon icon--help icon--primary-dark icon--material"
        viewBox="0 0 24 24"
      >
        <use xlink:href="#icon-help" href="#icon-help"></use>
      </svg>
      <span
        class="icon-text active"
        >{{ helpText ? helpText : 'help'}}</span
      ></span
    >
  </ng-template>
</li>
